import React from 'react';
import { ModalProvider, ModalWithProvider } from 'glints-aries/es/@next';

import {
  ActivateFreeTrialModalContext,
  useActivateFreeTrialModalContext,
} from './ActivateFreeTrialModalContext';
import useClaimCompanyProductFreeTrialOffer from './hooks/useClaimCompanyProductFreeTrialOffer';

export { useActivateFreeTrialModalContext };

type Props = {
  children: React.ReactNode;
};

export default function ActivateFreeTrialModalProvider({ children }: Props) {
  return (
    <ActivateFreeTrialModalContext.Provider
      value={useClaimCompanyProductFreeTrialOffer()}
    >
      <ModalProvider>
        <ModalWithProvider />
        {children}
      </ModalProvider>
    </ActivateFreeTrialModalContext.Provider>
  );
}
